import { membersApi } from '@/entities/Branch';
import type { AdminMember } from '../model/member.types';
import type { SearchParams, Pagination } from '@/shared/lib';
import type { MembersFilter } from '@/entities/Branch';

export async function searchAdminMembers(
  _searchUrl: string,
  searchParams: SearchParams
): Promise<{ data: AdminMember[]; metadata: Pagination }> {
  const page = searchParams.page ?? 1;
  const amount = searchParams.amount ?? 10;
  const trimmed = searchParams.search?.trim();
  const search = trimmed?.length ? trimmed : undefined;
  const sort = searchParams.sort?.sort;
  const order = searchParams.sort?.order;
  const filter = searchParams.filter as MembersFilter | undefined;
  const searchField = searchParams.searchField;

  const result = await membersApi.getMembers(
    page,
    amount,
    search,
    sort,
    order,
    { ...filter, includeInactiveMembers: true },
    searchField
  );
  const meta = result.metadata;

  return {
    data: (result.data ?? []) as AdminMember[],
    metadata: {
      total: meta?.total ?? 0,
      page: meta?.page ?? 1,
      itemsPerPage: meta?.itemsPerPage ?? amount,
      totalPages: meta?.totalPages ?? 0,
      isNextPage: (meta?.page ?? 1) < (meta?.totalPages ?? 0),
      isPreviousPage: (meta?.page ?? 1) > 1,
    },
  };
}
